import { observer } from 'mobx-react-lite';
import { TradePlanData } from '../../../../../../../classes/tradePlan/tradePlanData';
import { useTradePlanFormStore } from '../../../../../../../classes/tradePlan/tradePlanProvider';
import { colors } from '../../../../../../../colorVars';
import { Body4 } from '../../../../../../atomic/text/Text';
import style from './OptionChainsTable.module.css';
import { OptionData } from './optionType';
import { OptionChainsTableRow } from './OptionChainsTableRow';
import { returnOptionType } from '../../../../../../../stores/websocketStore/utils/mungingUtils/returnOptionType';

export const ValidOptionsTable = observer(() => {
  const tradePlanForm: TradePlanData = useTradePlanFormStore();
  const validOptions = tradePlanForm.optionManagement.validOptions;

  return (
    <table className={style.table}>
      <thead>
        <tr>
          <th>
            <Body4 color={colors.lightGrey}>Type</Body4>
          </th>
          <th>
            <Body4 color={colors.lightGrey}>Strike</Body4>
          </th>
          <th>
            <Body4 color={colors.lightGrey}>Date</Body4>
          </th>
        </tr>
      </thead>
      <tbody className={style.tbody}>
        {Object.values(validOptions).map((option: OptionData) => {
          const type = returnOptionType(option.symbol);
          return <OptionChainsTableRow data={option} key={option.symbol} type={type} />;
        })}
      </tbody>
    </table>
  );
});
